import { render, staticRenderFns } from "./_Instrucao.vue?vue&type=template&id=cb386414&scoped=true&"
import script from "./_Instrucao.vue?vue&type=script&lang=js&"
export * from "./_Instrucao.vue?vue&type=script&lang=js&"
import style0 from "./_Instrucao.vue?vue&type=style&index=0&id=cb386414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb386414",
  null
  
)

export default component.exports